/* PDP selling plans store setup */
(function(){
  document.addEventListener("alpine:init", function(){
    if(!Alpine.store("sellingPlans")){
      Alpine.store("sellingPlans", {
        defaultSellingPlanId: 3280535768,
        frequencies: [
          {id: 3280535768, name: "2 weeks", label: "Every 2 weeks"},
          {id: 3280568536, name: "4 weeks", label: "Every 4 weeks"},
          {id: 3280601304, name: "6 weeks", label: "Every 6 weeks"}
        ]
      });
    }
  });
})();
